import { IconCircleDashedLetterA, IconLogs } from '@tabler/icons-react';
import { IconCalendarCheck } from '@tabler/icons-react';
import api from '../../../../api';
import { FaExclamationTriangle, FaExclamationCircle } from "react-icons/fa"; // New icons for errors
import { useState, useEffect,useMemo } from 'react';
import { useAuth } from '../../../Layouts/context/Authcontext';
import PKTScoresSummary from '../../../../Data/DashboardData/QualityAuditor/PKTScoresSummary.json';
import { IconTools } from '@tabler/icons-react';
import AttendancePercentage from "./AttendancePercentage"
import { FiTrendingUp } from "react-icons/fi";
import { BiCalendarCheck } from "react-icons/bi";
import { HiOutlineChartBar } from "react-icons/hi";
import AuditedCountCard from './AuditedCountCard'; // Ensure correct relative path
import { Skeleton } from "@mui/material"; // Using Material-UI for sleek skeletons
import { getRoundRobinBaseUrl } from '../../../../loadBalancer';


function QualityAuditorDashboardView1(AuditorId) {
  const { accessToken } = useAuth();
  const [effectivenessPercentage, setEffectivenessPercentage] = useState();
  const [attendancePercentage, setAttendancePercentage] = useState("0");
  const [totalAttendanceDays, setTotalAttendanceDays] = useState("0");
  const [totalLeavesCurrentMonth, setTotalLeavesCurrentMonth] = useState("0");
  const [pktPercentage, setPktPercentage] = useState("0");
  const [nonFatalErrors, setNonFatalErrors] = useState([]);
  const [fatalErrors, setFatalErrors] = useState([]);
  const [auditedTarget, setAuditedTarget] = useState(0);
  const [auditedCompleted, setAuditedCompleted] = useState(0);
  const [performanceData, setPerformanceData] = useState({
    yesterday: 0,
    mtd: 0,
    ytd: 0,
  });

  const [toolEffectiveness, setToolEffectiveness] = useState({
    floorHours: 0,
    eprHours: 0,
    effectivenessPercentage: 0,
  });

  const [finalLoading, setFinalLoading] = useState(true);

  const [performanceDataLoading, setPerformanceDataLoading] = useState(false);
  const [pktLoading, setPktLoading] = useState(false);
  const [toolEffectivenessLoading, setToolEffectivenessLoading] = useState(false);
  const [attendanceLoading, setAttendanceLoading] = useState(false);
  const [auditedLoading, setAuditedLoading] = useState(false);
  const [errorSeverity, setErrorSeverity] = useState(false)



  const strokeColor = useMemo(() => {
    if (attendancePercentage < 40) return "#EF4444"; // Red (10-40%)
    if (attendancePercentage < 70) return "#F59E0B"; // Orange (40-70%)
    
    return "#10B981"; // Green (70-100%)
  }, [attendancePercentage]);

  // const [loading, setLoading] = useState(true);

//   // Call API when component mounts
//  useEffect(() => {
//   if(attendanceLoading && pktLoading && auditedLoading && toolEffectivenessLoading && performanceDataLoading && errorSeverity){
//     setFinalLoading(false)
//   }
// }, [attendanceLoading,pktLoading,auditedLoading,toolEffectivenessLoading,performanceDataLoading,errorSeverity])
  

  // Fetch Attendance Data
  const fetchAttendance = async () => {
    try {
      let baseUrls= getRoundRobinBaseUrl();
      const response = await api.get(`${baseUrls}/userDashboard/getAttendance`, {
        headers: { Authorization: `Bearer ${accessToken}` },
      });

      if (response.data.success && response.data.data.length > 0) {
      setAttendancePercentage(response.data.attendancePercentage);
        setTotalAttendanceDays(`${response.data.data[0].total_attendance_days}`);
        setTotalLeavesCurrentMonth(`${response.data.total_leaves_current_month}`);
        setAttendanceLoading(true)
      } else {
        console.error("Attendance API Error:", response.data.message);
      }
    } catch (error) {
      console.error("Error fetching Attendance:", error);
    }
  };

    // Fetch Audited Count Data
    const fetchAuditedCount = async () => {
      try {
        let baseUrls= getRoundRobinBaseUrl();
        const response = await api.get(`${baseUrls}/qaDashboard/getAuditedCount`, {
          headers: { Authorization: `Bearer ${accessToken}` },
        });
  
        if (response.data.success) {
          setAuditedTarget(response.data.auditedTarget);
          setAuditedCompleted(response.data.auditedCompleted);
          setAuditedLoading(true)
        } else {
          console.error("Error fetching audited count:", response.data.message);
        }
      } catch (error) {
        console.error("API error fetching audited count:", error);
      } finally {
        // setLoading(false);
      }
    };
  
    // Call API when component mounts
    useEffect(() => {
      fetchAuditedCount();
    }, [AuditorId])

  // Fetch PKT Data
  const fetchPKT = async () => {
    try {
      let baseUrls= getRoundRobinBaseUrl();
      const response = await api.get(`${baseUrls}/userDashboard/getPKT`, {
        headers: { Authorization: `Bearer ${accessToken}` },
      });

      if (response.data.success) {
        setPktPercentage(`${response.data.pkt_percentage}%`);
        setPktLoading(true)
      } else {
        console.error("PKT API Error:", response.data.message);
      }
    } catch (error) {
      console.error("Error fetching PKT:", error);
    }
  };

  // Call APIs on Component Mount
  useEffect(() => {
    fetchToolEffectiveness();
    fetchAttendance();
    fetchPKT();
  }, [AuditorId]);
      // Fetch Tool Effectiveness Data
  const fetchToolEffectiveness = async () => {
    try {
      let baseUrls= getRoundRobinBaseUrl();
      const response = await api.get(`${baseUrls}/userDashboard/getToolEffectiveness`, {
        headers: { Authorization: `Bearer ${accessToken}` },
      });

      if (response.data.success) {
        setEffectivenessPercentage(response.data.toolEffectiveness); // Update effectivenessPercentage state
        setToolEffectivenessLoading(true)
      } else {
        console.error("Tool Effectiveness API returned an error:", response.data.message);
      }
    } catch (error) {
      console.error("Error fetching tool effectiveness data:", error);
    }
  };

  

  
  

  // Fetch Performance & Tool Effectiveness Data
  const fetchData = async () => {
    try {
      let baseUrls= getRoundRobinBaseUrl();
      const response = await api.get(`${baseUrls}/qaDashboard/getDashBoardAuditedPercentage`, {
        // params: { auditorId: AuditorId },
        headers: { Authorization: `Bearer ${accessToken}` },
      });

      if (response.data.success) {
        const { previousDateAudited, monthlyAuditedData, yearlyAuditedData } =
          response.data.data;
      
        setPerformanceData({
          yesterday: previousDateAudited.length > 0 ?  previousDateAudited[0].yesterdayPercentage : 0,
          mtd:monthlyAuditedData.length > 0 ? monthlyAuditedData[0].monthlyPercentage : 0,
          ytd: yearlyAuditedData.length > 0 ? yearlyAuditedData[0].yearlyPercentage : 0,
        });
        setPerformanceDataLoading(true)
      } else {
        console.error('API returned an error:', response.data.message);
        setPerformanceData({ yesterday: 0, mtd: 0, ytd: 0 });
        setToolEffectiveness({ floorHours: 0, eprHours: 0, effectivenessPercentage: 0 });
      }
    } catch (error) {
      console.error('Error fetching performance data:', error);
    } finally {
      // setLoading(false);
    }
  };

  // Fetch Error Severity Data
  const fetchErrorSeverity = async () => {
    try {
      let baseUrls= getRoundRobinBaseUrl();
      const response = await api.get(`${baseUrls}/qaDashboard/getErrorSeviority`, {
        headers: { Authorization: `Bearer ${accessToken}` },
      });
      
      if (response.data.success) {
        setFatalErrors(response.data.topFatalErrors);
        setNonFatalErrors(response.data.topNonFatalErrors);
        setErrorSeverity(true)
      } else {
        console.error("Error Severity API returned an error:", response.data.message);
      }
    } catch (error) {
      console.error("Error fetching error severity data:", error);
    } finally {
      // setLoading(false);
    }
  };
  
  useEffect(() => {
    fetchErrorSeverity();
  }, [AuditorId]);

  useEffect(() => {
    fetchData();
    fetchToolEffectiveness();

  }, [AuditorId]);

  return (
    
    <div className="bg-gray-100 min-h-screen p-6">
   <h5 className="text-2xl font-bold text-center text-gray-800 mb-4"> Auditor Dashboard</h5>
<div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10">
  {/* Card Template */}
  {[
    {
      title: "Yesterday's Performance",
      value: performanceData.yesterday,
      icon: <FiTrendingUp size={28} />,
      border: 'border-[#EE1D23]',
      iconBg: 'bg-[#EE1D23]/10',
      iconColor: 'text-[#EE1D23]',
    },
    {
      title: "MTD Performance",
      value: performanceData.mtd,
      icon: <BiCalendarCheck size={28} />,
      border: 'border-[#1A2B5C]',
      iconBg: 'bg-[#1A2B5C]/10',
      iconColor: 'text-[#1A2B5C]',
    },
    {
      title: "YTD Performance",
      value: performanceData.ytd,
      icon: <HiOutlineChartBar size={28} />,
      border: 'border-[#EE1D23]',
      iconBg: 'bg-[#EE1D23]/10',
      iconColor: 'text-[#EE1D23]',
    },
  ].map((card, idx) => (
    <div
      key={idx}
      className={`p-6 rounded-2xl bg-white shadow-md border-l-4 ${card.border} hover:shadow-xl transition duration-300`}
    >
      <div className="flex items-center space-x-4">
        <div className={`p-3 rounded-xl ${card.iconBg} ${card.iconColor}`}>
          {card.icon}
        </div>
        <div>
          <h4 className="text-base font-medium text-gray-700">
            {card.title}
          </h4>
          <p className="text-3xl font-bold text-gray-900 mt-1">
            {card.value}%
          </p>
        </div>
      </div>
    </div>
  ))}
</div>


  <div className="grid :grid-cols-2 gap-3 mb-3 pt-2">
        <div className="sm:col-span-2 lg:col-span-8 h-auto  rounded-lg shadow-3xl">

   <div className="sm:col-span-2 lg:col-span-8 h-auto  from-blue-200 to-blue-50 p-6 rounded-xl shadow-3xl">
        <h5 className="text-2xl font-bold text-center text-gray-800 mb-4">📊 Employee Attendance Overview</h5>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">

          {/* Attendance & Leaves Quick Stats */}
          {/* Total Attendance Days - White Card with Circular Progress */}
        {/* Total Attendance Days - White Card with a Unique Circular Progress Bar */}
        {/* Total Attendance Days - White Card with Dark Shadow Effect */}
        <div className="panel bg-white shadow-2xl rounded-2xl p-6 flex flex-col items-center transition-transform duration-300 hover:scale-105 hover:shadow-3xl w-full h-64">
          
          {/* Title */}
          {/* Top gradient bar */}
          <div className="absolute top-0 left-0 w-full h-[10px] bg-gradient-to-r from-[#EE1D23] via-pink-500 to-[#1A2B5C] rounded-t-[2rem] z-0" />
          <h3 className="text-lg font-bold text-gray-800 uppercase tracking-wide">
            📅 Attendance Overview
          </h3>

          {/* Stylish Radial Progress Bar */}
          <div className="relative mt-4">
            <svg width="120" height="120" viewBox="0 0 120 120" className="relative">
              {/* Background Circle */}
              <circle cx="60" cy="60" r="50" stroke="lightgray" strokeWidth="10" fill="none" />
              {/* Progress Ring */}
              <circle
                cx="60" cy="60" r="50"
                stroke="url(#gradient)" strokeWidth="10" fill="none"
                strokeDasharray="314" strokeDashoffset={(1 - totalAttendanceDays / 30) * 314}
                strokeLinecap="round"
                className="transition-all duration-500"
              />
              {/* Gradient Definition */}
              <defs>
               <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="0%">
                <stop offset="0%" stopColor="#EE1D23" />
                <stop offset="100%" stopColor="#1A2B5C" />
              </linearGradient>

              </defs>
            </svg>

            {/* Centered Attendance Number */}
            <div className="absolute inset-0 flex items-center justify-center">
              <p className="text-3xl font-extrabold text-indigo-950">{totalAttendanceDays}</p>
            </div>
          </div>

          {/* Footer */}
          <p className="mt-4 text-lg font-semibold text-gray-700">Days Present This Month</p>
        </div>

      {/* Leaves This Month - White Card with Dark Shadow */}
      <div className="panel bg-white shadow-2xl rounded-2xl p-6 flex flex-col items-center transition-transform duration-300 hover:scale-105 hover:shadow-3xl w-full h-64">
        
        {/* Title */}
        {/* Top gradient bar */}
  <div className="absolute top-0 left-0 w-full h-[10px] bg-gradient-to-r from-[#EE1D23] via-pink-500 to-[#1A2B5C] rounded-t-[2rem] z-0" />
        <h3 className="text-lg font-bold text-gray-800 uppercase tracking-wide">
          🏖 Leave Summary
        </h3>

        {/* Mini Calendar Design */}
        <div className="relative flex flex-col items-center bg-gray-100 shadow-md p-4 rounded-xl w-28 h-28 mt-4">
          <IconCalendarCheck size={40} className="text-red-500 mb-2" />
          <p className="text-3xl font-extrabold text-gray-800">{totalLeavesCurrentMonth}</p>
          <p className="text-sm text-gray-600 mt-1">Leave Days</p>
        </div>

        {/* Footer */}
        <p className="mt-4 text-lg font-semibold text-gray-700">Balance work & rest</p>
      </div>
      {/* Circular Progress Attendance Percentage */}
      
            <AttendancePercentage attendancePercentage={attendancePercentage} />
             </div>
      </div>
        </div>
     </div>

      {/* Tool Effectiveness Card - Below YTD Performance */}
       <p className="text-2xl font-bold text-gray-800 text-center tracking-wide mt-14">
                📊 Tool Effectiveness &  PKTScores
         </p>
     <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-10">
      {/* Tool Effectiveness Card */}
      <div className="panel rounded-2xl mt-10 bg-gradient-to-r from-red-100 to-red-50 shadow-xl p-6 flex items-center space-x-5 transition-transform duration-300 hover:scale-105 hover:shadow-2xl h-44">
  {/* Icon Container */}
  <div className="bg-[#EE1D23]/20 p-4 rounded-full shadow-lg flex items-center justify-center">
    <IconTools size={36} className="text-[#EE1D23]" />
  </div>

  {/* Text Content */}
  <div className="flex flex-col justify-center">
    <h4 className="text-lg font-semibold text-gray-900 tracking-wide mb-1">
      Tool Effectiveness
    </h4>
    <p className="text-3xl font-extrabold text-gray-900">{effectivenessPercentage}</p>
    <p className="text-sm text-black mt-1">Based on EPR vs Floor Hours</p>
  </div>
</div>


      {/* PKT Scores Summary Card */}
      <div className="panel rounded-2xl mt-10 bg-gradient-to-br from-blue-100 to-blue-50 shadow-xl p-6 flex items-center space-x-5 transition-transform duration-300 hover:scale-105 hover:shadow-2xl h-44">
  {/* Icon Container */}
  <div className="bg-[#1A2B5C] p-4 rounded-full shadow-lg flex items-center justify-center">
    <IconLogs size={36} className="text-white" />
  </div>

  {/* Text Content */}
  <div className="flex flex-col justify-center">
    <h4 className="text-lg font-semibold text-gray-800 tracking-wide mb-1">
      {PKTScoresSummary.Description}
    </h4>
    <p className="text-3xl font-extrabold text-[#1A2B5C]">{pktPercentage}</p>
    <p className="text-sm text-gray-500 mt-1">PKT Accuracy Percentage</p>
  </div>
</div>

      </div>

    {/* Fatal & Non-Fatal Error Cards */}
     <p className="text-2xl font-bold text-gray-800 text-center tracking-wide mt-14 mb-6">
            📊 Fatal & Non-Fatal Error
          </p>
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10">

  {/* 🔴 Fatal Errors */}
  <div className="relative bg-white rounded-3xl p-6 shadow-xl overflow-hidden group transition-transform duration-300 hover:scale-[1.03]">
    {/* Glowing Top Border */}
    <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-[#EE1D23] via-red-400 to-[#EE1D23] rounded-t-3xl" />
    {/* Outer Glow Ring */}
    <div className="absolute inset-0 border-2 border-transparent rounded-3xl group-hover:border-[#EE1D23]/30 group-hover:shadow-[0_0_20px_#EE1D23aa] transition-all" />

    <div className="flex flex-col items-center space-y-3 mt-2">
      <div className="p-4 bg-[#EE1D23]/10 rounded-full shadow-md border border-[#EE1D23]/20">
        <FaExclamationTriangle className="text-[#EE1D23]" size={36} />
      </div>
      <h3 className="text-xl font-extrabold text-[#EE1D23] tracking-wider">Fatal Errors</h3>
    </div>

    <div className="mt-5 w-full text-center">
      {fatalErrors.length > 0 ? (
        <div className="space-y-3">
          {fatalErrors.map((error, idx) => (
            <div key={idx} className="bg-red-50 p-4 rounded-lg border-l-4 border-[#EE1D23] shadow-sm text-left">
              <h4 className="text-md font-semibold text-[#EE1D23] flex items-center gap-2">
                <FaExclamationTriangle size={16} /> {error["Error Sub Category"]}
              </h4>
              <p className="text-sm text-gray-700 mt-1 pl-6">
                Total Count: <span className="font-bold">{error.totalFatalErrorCount}</span>
              </p>
            </div>
          ))}
        </div>
      ) : (
        <div className="mt-6 bg-[#FDECEA] border border-red-300 text-[#B91C1C] px-6 py-4 rounded-xl shadow-sm">
          <h5 className="font-bold text-lg">✅ No Fatal Errors</h5>
          <p className="text-sm mt-1">System stable. No critical issues detected.</p>
        </div>
      )}
    </div>
  </div>

  {/* 🔵 Non-Fatal Errors */}
  <div className="relative bg-white rounded-3xl p-6 shadow-xl overflow-hidden group transition-transform duration-300 hover:scale-[1.03]">
    {/* Glowing Top Border */}
    <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-[#1A2B5C] via-blue-500 to-[#1A2B5C] rounded-t-3xl" />
    {/* Outer Glow Ring */}
    <div className="absolute inset-0 border-2 border-transparent rounded-3xl group-hover:border-[#1A2B5C]/30 group-hover:shadow-[0_0_20px_#1A2B5Caa] transition-all" />

    <div className="flex flex-col items-center space-y-3 mt-2">
      <div className="p-4 bg-[#1A2B5C]/10 rounded-full shadow-md border border-[#1A2B5C]/20">
        <FaExclamationCircle className="text-[#1A2B5C]" size={36} />
      </div>
      <h3 className="text-xl font-extrabold text-[#1A2B5C] tracking-wider">Non-Fatal Errors</h3>
    </div>

    <div className="mt-5 w-full text-center">
      {nonFatalErrors.length > 0 ? (
        <div className="space-y-3">
          {nonFatalErrors.map((error, idx) => (
            <div key={idx} className="bg-[#F1F5FB] p-4 rounded-lg border-l-4 border-[#1A2B5C] shadow-sm text-left">
              <h4 className="text-md font-semibold text-[#1A2B5C] flex items-center gap-2">
                <FaExclamationCircle size={16} /> {error["Error Sub Category"]}
              </h4>
              <p className="text-sm text-gray-700 mt-1 pl-6">
                Total Count: <span className="font-bold text-[#EE1D23]">{error.totalNonFatalErrorCount}</span>
              </p>
            </div>
          ))}
        </div>
      ) : (
        <div className="mt-6 bg-[#E8F0FE] border border-blue-300 text-[#1A2B5C] px-6 py-4 rounded-xl shadow-sm">
          <h5 className="font-bold text-lg">✅ No Non-Fatal Errors</h5>
          <p className="text-sm mt-1">Smooth operation. No minor issues found.</p>
        </div>
      )}
    </div>
  </div>

  {/* ✅ Audited Count */}
  <div className="relative bg-white rounded-3xl p-6 shadow-xl overflow-hidden group transition-transform duration-300 hover:scale-[1.03]">
    {/* Glowing Top Border */}
    <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-[#1A2B5C] via-[#EE1D23] to-[#1A2B5C] rounded-t-3xl" />
    {/* Outer Glow Ring */}
    <div className="absolute inset-0 border-2 border-transparent rounded-3xl group-hover:border-[#1A2B5C]/20 group-hover:shadow-[0_0_20px_#1A2B5Caa] transition-all" />
    
    {/* Component */}
    <div className="mt-2 z-10 relative">
      <AuditedCountCard auditedTarget={auditedTarget} auditedCompleted={auditedCompleted} />
    </div>
  </div>

</div>

     
    </div>
  );
}

export default QualityAuditorDashboardView1;
